import { useSelector } from 'react-redux';

export const FullPermissions = () => useSelector(state => state.permissions);
